var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneToFiveLevel2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9fcc00;}.cls-2{fill:#5c7200;}.cls-3{fill:none;stroke:#5c7200;stroke-linecap:round;stroke-miterlimit:10;stroke-width:30px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2",
    "data-name": 2
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.11,584.33A285,285,0,0,1,98.59,97.81a285,285,0,0,1,403,403.05A283.13,283.13,0,0,1,300.11,584.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.11,29.33A270.08,270.08,0,0,1,405.2,548.13,270.08,270.08,0,0,1,195,50.54,268.34,268.34,0,0,1,300.11,29.33m0-30c-165.68,0-300,134.32-300,300s134.32,300,300,300,300-134.31,300-300-134.31-300-300-300Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151,373c5,6.92,57.13,77,150,77,8.52,0,95.87-1.54,150-77"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 226.11,
    cy: 232.69,
    rx: 25,
    ry: 42.65
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 374.11,
    cy: 232.69,
    rx: 25,
    ry: 42.65
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneToFiveLevel2);
export default __webpack_public_path__ + "static/media/one_to_five_level_2.3eeedae575f77bdd1ae38953d1bd0877.svg";
export { ForwardRef as ReactComponent };